import Noise from "src/components/Noise/Noise";
import Touchable from "src/components/Touchable";
import IconBrush from "src/icons/IconBrush";
import IconCaretFilled from "src/icons/IconCaretFilled";
import { radiusMedium } from "src/styles/radius";
import { paddingMedium, paddingSmall } from "src/styles/spacing";
import { BlurView } from "src/swsh-native";
import { FLOATING_THEME_CUSTOMIZE_BUTTON_WIDTH } from "../constants";

const FloatingThemeCustomizeButton = ({ onPress }: { onPress?: () => void }) => {
	return (
		<BlurView
			style={{
				width: FLOATING_THEME_CUSTOMIZE_BUTTON_WIDTH,
				marginBottom: paddingMedium,
				borderRadius: radiusMedium,
				overflow: "hidden",
			}}
			intensity={"floating-menu"}
		>
			<Noise
				opacity={0.1}
				style={{
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
				}}
			/>
			<Touchable
				testID="CustomThemeButton"
				containerStyle={{
					padding: paddingSmall,
					borderRadius: radiusMedium,
				}}
				style={{
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					columnGap: paddingSmall,
				}}
				onPress={onPress}
			>
				<IconBrush size={20} />
				<IconCaretFilled size={8} />
			</Touchable>
		</BlurView>
	);
};

export default FloatingThemeCustomizeButton;
